var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          staticClass: "dialog-container",
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleCerrar()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", { staticClass: "toolbar" }, [
                    _vm._v(
                      "\n          Detalle de Serie " +
                        _vm._s(_vm.detallePatente) +
                        "\n        "
                    )
                  ]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "card" },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md12: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm12: "", md12: "" } },
                                          [
                                            _c(
                                              "v-tabs",
                                              { staticClass: "ndv_modal_tabs" },
                                              [
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step = "os"
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("OS")]
                                                ),
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step = "cuadre"
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Cuadre")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("v-divider"),
                                    !_vm.loading
                                      ? _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              sm12: "",
                                              md12: "",
                                              "mt-5": ""
                                            }
                                          },
                                          [
                                            _vm.step === "os"
                                              ? _c("ConfigurarDetalleForm", {
                                                  attrs: {
                                                    detalleId: _vm.detalleId,
                                                    patente: _vm.detallePatente,
                                                    estado: _vm.Cuadratura
                                                  }
                                                })
                                              : _vm.step === "cuadre"
                                              ? _c("CuadreServicioForm", {
                                                  attrs: {
                                                    patente: _vm.detallePatente,
                                                    detalleId: _vm.detalleId,
                                                    detalleglosa:
                                                      _vm.detalleglosa,
                                                    Categoriaglosa:
                                                      _vm.Categoriaglosa,
                                                    estado: _vm.estadoLocal
                                                  },
                                                  on: {
                                                    updateEstado:
                                                      _vm.handleEstadoActualizado,
                                                    glosaUpdated:
                                                      _vm.handleGlosaUpdated
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }